import { _, React, classNames, withStyles, StyledProps } from '@api'
import { Card, CardHeader, CardContent, CardActions } from '@material-ui/core'
import { Close, NoteAdd } from '@material-ui/icons'
import { FlatButton, NoteItem, NoteDefinition, CentricTheme } from 'centric-ui-components'

const styles = (theme: CentricTheme) => ({
  container:   {
    height:   '100vh',
    width:    '100%',
    position: 'absolute',
    bottom:   0
  },
  card:        {
    height:       'calc(100vh/1.6)',
    position:     'absolute',
    bottom:       0,
    width:        '100%',
    zIndex:       999,
    boxShadow:    '0 4px 5px 0 rgba(0, 0, 0, 0.2), 0 3px 14px 3px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14)',
    borderRadius: 0
  },
  title:       {
    color: 'rgba(27, 27, 27, 0.87)'
  },
  cardHeader:  {
    borderBottom: 'thin solid #dedede',
    height:       64
  },
  action:      {
    margin:  '3px 0',
    cursor:  'pointer',
    color:   'rgba(0, 0, 0, 0.54)',
    '& svg': {
      width:  18,
      height: 18
    }
  },
  footer:      {
    height:          64,
    display:         'flex',
    alignItems:      'center',
    borderTop:       'thin solid #dedede',
    justifyContent:  'flex-end',
    padding:         0,
    position:        'absolute',
    width:           '100%',
    bottom:          0,
    backgroundColor: '#FFF'
  },
  cardContent: {
    padding: 0,
    overflow:     'hidden',
    overflowY:    'auto',
    height:       'calc(100% - 128px)'
  },
  noteButton:  {
    borderRadius:    0,
    height: 36,
    whiteSpace: 'nowrap',
    right: theme.spacing(),
    backgroundColor: '#FFFFFF',
    '&:hover':       {
      backgroundColor: '#FFFFFF'
    }
  },
  noteIcon:    {
    width:     20,
    height:    20,
    marginTop: 2
  },
  notesCard:   {
    '&:last-child': {
      borderBottom: 'none'
    }
  }
})

interface MyProps extends StyledProps {
  notes: Array<NoteDefinition>
  onClickMoreMenuNote: (e) => void
  onClickAddNote?: (e) => void
}

export class NotesListComponent extends React.Component<MyProps> {
  static defaultProps = {
    rowsMax: 5,
    onClickAddNote: () => {},
    onClickMoreMenuNote: () => {}
  }

  render() {
    const {className, notes, classes, onClickAddNote, onClickMoreMenuNote} = this.props
    return (
      <div className={classNames(className, classes.container)}>
        <Card className={classes.card}>
          <CardHeader
            titleTypographyProps={{
              classes: {headline: classes.title}
            }}
            classes={{root: classes.cardHeader, action: classes.action}}
            title={'Notes'}
            action={<Close/>}/>
          <CardContent classes={{root: classes.cardContent}}>
            {
              _.map(notes, (note, i) => (
                <NoteItem key={i} comment={note} onClickMoreMenu={onClickMoreMenuNote} classes={{listItem: classes.notesCard}}/>
              ))
            }
          </CardContent>
          <CardActions classes={{root: classes.footer}}>
            <FlatButton
              onClick={onClickAddNote}
              key={'product-footer-save'}
              classes={{root: classes.noteButton}}>
              Add Note
            </FlatButton>
          </CardActions>
        </Card>
      </div>
    )
  }
}

@(withStyles as any)(styles)
export class NotesList extends NotesListComponent {}



// WEBPACK FOOTER //
// ./src/shared/components/ui/widgets/NotesList.tsx